import s from "./Left.module.css"
import { img, CheckIcon, Logo, FleetLogo } from "./components/LeftIcon.js"
import { isLite } from "./../lite.js";

export default function Left(){
    const items = [{
        icon: CheckIcon,
        title: "Dispatchers",
    }, {
        icon: CheckIcon,
        title: "Fleet Owners",
    }, {
        icon: CheckIcon,
        title: "Truck Drivers",
    }, {
        icon: CheckIcon,
        title: "Trucking Accountants",
    }, {
        icon: CheckIcon,
        title: "Operations Managers",
    }]

    return <div className={s.wrapper}>
        {isLite ? FleetLogo : Logo}
        <div className={s.welcome} style={{whiteSpace: "nowrap"}}>All-In-One Trucking Software</div>
        <div className={s.subTitle}>Easy-To-Use TMS for Trucking Professionals</div>
        {items.map((item, index) => <div key={index} className={s.descWrapper}>            
            {item.icon}
            <div className={s.leftRight}>
                <div className={s.title}>{item.title}</div>
            </div>
        </div>
        )}
        {img}
    </div>
}